import { t, formatTime } from './portal-utils.js'
import {
  renderAttentionItems,
  renderBriefItems,
  renderExecutionItems,
  renderMigaState,
  renderMigaMeta,
} from './portal-renderers.js'
import { setSafeHtml } from './safe-html.js'
import {
  isSeededFixtureWorkspace,
  readSeededQueryFromStorage,
  writeSeededQueryToStorage,
} from './portal-seeded-fixtures.js'

export function updateSnapshotUIDegraded(root: Element, message: string): void {
  const attentionNote = root.querySelector('#op-attention-note')
  const executionNote = root.querySelector('#op-execution-note')
  if (attentionNote) attentionNote.textContent = message
  if (executionNote) executionNote.textContent = message
}

export function updateSnapshotUI(root: Element, snapshot: any): void {
  updateHealthUI(root, snapshot)
  updateAttentionUI(root, snapshot)
  updateApprovalUI(root, snapshot)
  updateExecutionUI(root, snapshot)
  updateFeedUI(root, snapshot)
}

function updateHealthUI(root: Element, snapshot: any): void {
  const healthScore = Number(snapshot?.healthScore?.score || 0)
  const healthDelta = Number(snapshot?.healthScore?.delta || 0)
  root.querySelector('#op-health-score')!.textContent = Number.isFinite(healthScore) ? `${healthScore}` : '—'
  root.querySelector('#op-health-delta')!.textContent = healthDelta === 0 ? 'Flat vs yesterday' : healthDelta > 0 ? `Up ${Math.round(healthDelta)} vs yesterday` : `Down ${Math.abs(Math.round(healthDelta))} vs yesterday`
}

function updateAttentionUI(root: Element, snapshot: any): void {
  root.querySelector('#op-attention-count')!.textContent = `${Number(snapshot?.inbox?.watchAttention || 0)}`
  root.querySelector('#op-attention-note')!.textContent = t(snapshot?.startup?.blockReason) || `${Number(snapshot?.approvals?.pending || 0)} approvals and ${Number(snapshot?.inbox?.watchAttention || 0)} watch alerts are live.`
}

function updateApprovalUI(root: Element, snapshot: any): void {
  root.querySelector('#op-pending-approvals')!.textContent = `${Number(snapshot?.approvals?.pending || 0)}`
}

function updateExecutionUI(root: Element, snapshot: any): void {
  root.querySelector('#op-execution-count')!.textContent = `${Number(snapshot?.executions?.total || 0)}`
  root.querySelector('#op-execution-note')!.textContent = snapshot?.executions?.latestExecutedAt ? `Latest execution ${formatTime(snapshot.executions.latestExecutedAt)}` : 'No recorded executions yet.'
}

function updateFeedUI(root: Element, snapshot: any): void {
  setSafeHtml(root.querySelector('#op-attention-feed'), renderAttentionItems(snapshot?.watch?.attention?.items || []))
  setSafeHtml(root.querySelector('#op-brief-timeline'), renderBriefItems(snapshot?.briefTimeline || []))
  setSafeHtml(root.querySelector('#op-execution-trail'), renderExecutionItems(snapshot?.executions?.items || []))
}

export function updateMigaFromSnapshot(root: Element, snapshot: any, workspaceSelect: HTMLSelectElement, migaOutput: Element, migaMeta: HTMLElement): void {
  const workspaceId = t(workspaceSelect?.value)
  const recentIntelligence = Array.isArray(snapshot?.intelligence?.recentQueries) ? snapshot.intelligence.recentQueries[0] : null
  if (recentIntelligence?.content) {
    setSafeHtml(migaOutput, renderMigaState(recentIntelligence))
    migaMeta.textContent = renderMigaMeta(recentIntelligence)
    if (isSeededFixtureWorkspace(workspaceId)) {
      writeSeededQueryToStorage(workspaceId, recentIntelligence)
    }
    return
  }
  if (isSeededFixtureWorkspace(workspaceId)) {
    const seededQuery = readSeededQueryFromStorage(workspaceId)
    if (seededQuery?.content) {
      setSafeHtml(migaOutput, renderMigaState(seededQuery))
      migaMeta.textContent = renderMigaMeta(seededQuery)
    }
  }
}
